export { default } from '../terms-and-conditions';
